// src/pages/About.js
import React, { useEffect, useState } from 'react';
import '../styles/BellaBizarreStyle.css';
import { db } from '../firebaseConfig';
import { doc, onSnapshot } from 'firebase/firestore';

export default function About() {
    const [aboutText, setAboutText] = useState('');
    const [aboutImageUrl, setAboutImageUrl] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const d = doc(db, 'siteContent', 'about');
        const unsub = onSnapshot(
            d,
            (snap) => {
                const data = snap.data();
                setAboutText(data?.aboutText || '');
                setAboutImageUrl(data?.aboutImageUrl || '');
                setLoading(false);
            },
            () => setLoading(false)
        );
        return unsub;
    }, []);

    if (loading) {
        return <div className="outer-about-container"><p>Loading…</p></div>;
    }

    return (
        <div className="outer-about-container">
            <div className="page-headline" id="about-title">
                <h1>About Bella Bizarre / Celene Harder</h1>
            </div>

            <div className="about-container fade-in">
                <div className="image-container">
                    {aboutImageUrl ? (
                        <img className="about-image" src={aboutImageUrl} alt="About feature" />
                    ) : null}
                </div>

                <div className="text-container">
                    {aboutText ? (
                        <p style={{ whiteSpace: 'pre-wrap' }}>{aboutText}</p>
                    ) : (
                        <p>Coming soon.</p>
                    )}
                </div>
            </div>
        </div>
    );
}
